import axios from './axios';
import { toCategory, toAPICategory } from './transformers/categoryTransformers';

const headers = (bearerToken) => ({
  Authorization: `Bearer ${bearerToken}`,
});

export const getAllCategories = async ({ bearerToken }) => {
  if (!bearerToken) {
    throw new Error('getAllCategories: missing parameters bearerToken');
  }
  const response = await axios({
    url: '/definition/categories',
    method: 'get',
    headers: headers(bearerToken),
  });

  return response.data.categories.map(toCategory);
};

export const getCategory = async ({ bearerToken }, id) => {
  if (!(bearerToken)) {
    throw new Error('getCategory: missing parameters bearerToken');
  }
  const response = await axios({
    url: `/definition/categories/${id}`,
    method: 'get',
    headers: headers(bearerToken),
  });

  return toCategory(response.data);
};

export const putCategory = async ({ bearerToken }, id, category) => {
  if (!(bearerToken)) {
    throw new Error('putCategory: missing parameters bearerToken');
  }
  await axios({
    url: `/definition/categories/${id}`,
    method: 'put',
    headers: headers(bearerToken),
    data: toAPICategory(category),
  });
  // For some reason, we don't return the category after the put...so we need an extra call.
  return getCategory({ bearerToken }, id);
};

export const deleteCategory = async ({ bearerToken }, id) => {
  if (!bearerToken) {
    throw new Error('deleteCategory: missing parameters bearerToken');
  }
  return axios({
    url: `/definition/categories/${id}`,
    method: 'DELETE',
    headers: headers(bearerToken),
  });
};

export default {
  deleteCategory,
  putCategory,
  getCategory,
  getAllCategories,
};
